import {
  StateRule,
  StateTransitionOptions,
  StateResult,

  StateNavigationAction,
  Transition,
  // eslint-disable-next-line
  addNavigationElement,
  // eslint-disable-next-line
  addEmptyNavigationElement,
  addPreviousNext,
  // eslint-disable-next-line
  addPrevious,
  // eslint-disable-next-line
  addNext,  
  newTransition,
  newTransitionCondition
} from "../StateInterfaces";
import { NavigatonIcons } from "@/business/application/NavConst";
import {Commands} from "@/business/application/commands/Command";
import { BaseState } from "../StateMachine";
import { StateFishing } from "./StateFishing";
import { Resource } from "@/infrastructure/resource/resource";
//import { StateFishBookEntry } from "./StateFishBookEntry";


export class StateFishBook extends BaseState {

  private mainState = "FishBook";
  private startState = "FishBook"
  private static transitions: Transition[] = [];  
  private static callingState : StateResult = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''}
  private isDirectionNext = false

  // Diesen Status setzen wenn es auf den Main-Status zurück geht. 
  private isDirectionPreviousParent = true

  public constructor() {
    super()    
    
  }


  
  public next(rule: StateRule, options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, false, this.mainState);
  }
  public previous(rule: StateRule,options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, true, this.mainState);
  }

  protected calculateState(rule: StateRule,options: StateTransitionOptions, isPrevious: boolean, mainState: string): StateResult {
    this.isDirectionNext = ! isPrevious
    const context = this.getContext()
    const currentResultState = context.getCurrentResultState();

    if ( isPrevious && this.isDirectionPreviousParent && currentResultState.newState === "FishBook") {
      return this.checkResultState(StateFishBook.callingState);
    }

    let condition = this.calculateBusinessConditions(rule,this.getContext().getCurrentState());
    if ( condition === undefined || condition === null || condition.length === 0 || condition === "") {
     
      if ( currentResultState.newState === "FishBook"  && this.isDirectionNext && condition === "") {
        condition = "FishBookFilter";
      }
     


      if ( currentResultState.newState === "FishBookFilter"  && !this.isDirectionNext && condition === "") {
        condition = "FishBook";
      }
      if ( currentResultState.newState === "FishBook"  && !this.isDirectionNext && condition === "") {
        condition = "Fishing";
      }
    }

    if ( this.isDirectionNext ) {
      const nextTransition = this.getTransitions().filter(row => { 
        if ( row.nav !== StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(nextTransition[0], options);
    } else {
      const previosTransition = this.getTransitions().filter(row => { 
        if ( row.nav === StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(previosTransition[0], options);
    }
  }


  protected calculateBusinessConditions(rule: StateRule, resultState: StateResult): string {
    if ( rule.conditions === undefined || rule.conditions === null || rule.conditions.length === 0 ) {
      return "";
    }

    if (rule.conditions.length == 1) {
      return rule.conditions[0].value;
    }

    return "";
  }


  private getCallingState(condition: string) : StateResult {
    if (this.isDirectionPreviousParent) { 
      // Condition = "Login"
      StateFishBook.callingState.newMainState = condition
      StateFishBook.callingState.newState = condition
      StateFishBook.callingState.routeName = condition
      StateFishBook.callingState.oldMainState = this.mainState
      StateFishBook.callingState.oldState = this.startState

      return StateFishBook.callingState;
    }
     StateFishBook.callingState = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''};
     return StateFishBook.callingState;
  }

  public getStartTransition(condition: string) : StateResult {
    StateFishBook.transitions = []
    this.getTransitions()
    //if ( condition !== this.mainState) {
      StateFishBook.callingState = this.getCallingState(condition);
    //}
    const t = this.getTransitions()[0];
    return this.getTransition(t);
  }



  protected checkState( transition: Transition, options: StateTransitionOptions): StateResult {
    let newMainState = this.mainState    
    let skip = false
    const newResultState: StateResult = this.getTransition(transition)

    if ( this.isDirectionPreviousParent && !this.isDirectionNext) {
      newMainState = StateFishBook.callingState.oldMainState
    }
    else {      
      newMainState = transition.newMainState
      if (transition.newState == "")
        skip = true
    }

    if (!options.lookahead && transition.newState != "") {
      return this.changeResultState(transition.newMainState, newResultState);
    }
    return newResultState;
  }

  private checkResultState( stateResult: StateResult ) : StateResult {  
    const newResultState = StateFishBook.callingState;    
    return this.changeResultState(stateResult.newMainState, newResultState);      
  }

  private changeResultState(newMainStatePar: string , compResultState: StateResult) : StateResult {
    let newState: any;
    switch (newMainStatePar) {
        case "Fishing":
          newState = new StateFishing();
          compResultState = newState.getStartTransition("Fishing")
          this.getContext().transitionTo(newState,compResultState);
          break;          
        default:
          this.getContext().transitionTo(new StateFishBook(), compResultState);        
    }
    return compResultState;
  }




  //-- Sammlung aller Statusübergänge
  public getTransitions(): Transition[] {
    if (StateFishBook.transitions.length === 0) {

      //__ Start State egal von welcher Stufe aus
      //
      let t: Transition = { mainState: "*", newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: "*", newState: this.startState, condition: "Start"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addEmptyNavigationElement(t,2);
      t = addNavigationElement(t,3,{command: Commands.Pdf, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Pdf",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Pdf });
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateFishBook.transitions.push(t);

      t = { mainState: this.mainState, newMainState: "WildBookFilter", nav: StateNavigationAction.Next, oldState: this.startState, newState: "FishBookFilter", condition: "FishBookFilter"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateFishBook.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "FishBook", condition: "FishBookFilterRequest"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addEmptyNavigationElement(t,2);
      t = addNavigationElement(t,3,{command: Commands.Pdf, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Pdf",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Pdf });
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateFishBook.transitions.push(t);


      //__ Backward Previous gesetzt
      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "FishBookFilter", newState: "FishBook", condition: "FishBook"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addEmptyNavigationElement(t,2);
      t = addNavigationElement(t,3,{command: Commands.Pdf, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Pdf",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Pdf });
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateFishBook.transitions.push(t);
     
    }
    return StateFishBook.transitions;
  }
}
